<template>

  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Manage</h3>
    </div>
    <form id="user" v-on:submit="save">
      <div class="card-body">
        <div class="tab-content">
          <div class="tab-pane active" id="activity">
            <div class="row">
              <div class="col-md-4" v-if="!user.Id">
                <div class="form-group">
                  <label>Campus</label>
                  <select class="form-control form-control-sm" v-model="user.CampusID" v-on:change="loadEmployees()" required>
                    <option value="">--Select--</option>
                    <option v-for="item in campuses" :value="item.CampusID" v-text="item.Name"></option>
                  </select>
                </div>
              </div>
              <div class="col-md-4" v-else>
                <div class="form-group">
                  <label>Campus</label>
                  <label disabled class="form-control">{{campuses.find(x => x.CampusID == user.CampusID).Name}}</label>
                </div>
              </div>
              <div class="col-md-8" v-if="!user.Id">
                <div class="form-group">
                  <label>Employee</label>
                  <v-select :options="employees" label="_Name" v-model="altEmp" v-on:input="employeeChange()">
                    <template #search="{attributes, events}">
                      <input class="vs__search"
                             :required="!altEmp"
                             v-bind="attributes"
                             v-on="events" />
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-md-8" v-else>
                <div class="form-group">
                  <label>Employee</label>
                  <label v-text="user.FullName" disabled class="form-control"></label>
                </div>
              </div>
            </div>
            <div class="row" v-if="altEmp || user.Id">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Username</label>
                  <input id="u1" name="u1" class="form-control" autocomplete="off" v-model="user.UserName" required />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Email</label>
                  <input class="form-control" autocomplete="off" v-model="user.Email" required />
                </div>
              </div>
              <div class="col-md-4" v-if="!user.Id">
                <div class="form-group">
                  <label>Password</label>
                  <input id="p1" name="p1" type="password" autocomplete="off" class="form-control" v-model="user.Password" required />
                </div>
              </div>
              <div class="col-md-4" v-if="!user.Id">
                <div class="form-group">
                  <label>Confirm Password</label>
                  <input type="password" autocomplete="off" class="form-control" v-model="user.ConfirmPassword" required />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.tab-content -->
      </div>
      <div class="card-footer">
        <a class="btn btn-primary" href="../Administration/ListEmployeeUser">Back to List</a>
        <div class="float-right">
          <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
          <input type="submit" value="Save" class="btn btn-success  " />
        </div>
      </div>
    </form>
  </div>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
      sendEmp: Function,
      sendImg: Function,
    },
    data() {
      return {
        campuses: [],
        employees: [],
        user: { Id: '', CampusID: '', EmployeeID: null, FullName: '', DepartmentID: '', UserName: '', Password: '', Email: '' },
        altEmp: null,
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {

        var id = "";

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams) {
          id = urlParams.get('id');

          //var uri = window.location.toString();
          //if (uri.indexOf("?") > 0) {
          //  var clean_uri = uri.substring(0, uri.indexOf("?"));
          //  window.history.replaceState({}, document.title, clean_uri);
          //}
        }

        startReq();
        var vm = this;
        axios.get('/api/RoleApi/pageLoadEmployeeUser?id=' + id)
          .then(function (res) {
            if (res.data.status) {
              vm.campuses = res.data.campuses;
              if (res.data.user) {
                vm.user = res.data.user;
              }
            }
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      loadEmployees() {
        this.altEmp = null;
        if (this.user.CampusID) {
          startReq();
          var vm = this;
          axios.get('/api/RoleApi/loadEmployees?campusID=' + vm.user.CampusID)
            .then(function (res) {
              if (res.data.status)
                vm.employees = res.data.employees;
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },

      employeeChange() {
        if (this.altEmp && this.user.CampusID) {
          startReq();
          var vm = this;
          axios.get('/api/RoleApi/loadEmployeeUserDetail?empID=' + vm.altEmp.EmployeeID + '&campusID=' + vm.user.CampusID)
            .then(function (res) {
              if (res.data.user) {
                toastr.info("User already created");
                vm.altEmp = null;
              }
              else {
                vm.user.UserName = vm.altEmp.CNIC;
                vm.user.Password = vm.altEmp.CNIC;
                vm.user.ConfirmPassword = vm.altEmp.CNIC;
              }
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },

      save(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        if (!vm.user.Id) {
          axios.post('/api/RoleApi/saveEmployeeUser', {
            Id: vm.user.Id,
            UserType: 0,
            EmployeeID: vm.altEmp.EmployeeID,
            FullName: vm.altEmp.FullName,
            DepartmentID: vm.altEmp.DepartmentID,
            CampusID: vm.user.CampusID,
            UserName: vm.user.UserName,
            Password:  vm.user.Password,
            ConfirmPassword:  vm.user.ConfirmPassword,
            Email: vm.user.Email
          })
            .then(function (res) {
              endReq();
              if (res.data.status) {
                toastr.success("Saved Successfully", "Done");
                vm.clear();
              }
              else {
                if (res.data.errors) {
                  res.data.errors.forEach(function (item) {
                    toastr.error(item.Description);
                  });
                }
                else
                  toastr.error(res.data.msg);
              }


            }).catch(function (err) {
              endReq();
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            })
        }
        else {
          axios.post('/api/RoleApi/saveEmployeeUser', {
            Id: vm.user.Id,
            UserType: 0,
            FullName: vm.user.FullName,
            DepartmentID: 0, // vm.altEmp.DepartmentID,
            UserName: vm.user.UserName,
            Password: 'Alphabet(N)',
            ConfirmPassword: 'Alphabet(N)',
            Email: vm.user.Email
          })
            .then(function (res) {
              endReq();
              if (res.data.status) {
                toastr.success("Saved Successfully", "Done");
                vm.clear();
              }
              else {
                if (res.data.errors) {
                  res.data.errors.forEach(function (item) {
                    toastr.error(item.Description);
                  });
                }
                else
                  toastr.error(res.data.msg);
              }


            }).catch(function (err) {
              endReq();
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            })
        }
      },

      checkFile(file) {
        if (file == null) {
          return false;
        }

        if (file.size > 500000) {
          toastr.error("file size is large maximum 500 kb allowed", "Error!");

          return false;
        }

        if (file.type != "image/jpeg" && file.type != "image/png") {
          toastr.error("Invalid File! only JPG and PNG is allowed");
          return false;
        }

        return true;
      },

      onfileupload: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var image = new Image;
          var reader = new FileReader;
          reader.onload = (e) => {
            this.img = e.target.result
            this.sendImg(this.img);
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
        else {
          $('#profileimg').val('');
        }
      },

      clear() {
        this.employees = [];
        this.user = { CampusID: '', EmployeeID: null, FullName: '', DepartmentID: '', UserName: '', Password: '' };
        this.altEmp = null;
      }

    }
  })</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>





// WEBPACK FOOTER //
// src/components/core/createEmployeeUser.vue